/* RESPONSIBLE TEAM: team-reporting */
/* === ⚠️ THIS FILE CURRENTLY USES DEPRECATED PATTERNS ⚠️ === */
/* === 🔗 For more information visit https://go.inter.com/ember-best-practices 🔗 */
/* === 🚀 Please consider refactoring & removing some of the comments below when working on this file 🚀 */
/* eslint-disable @intercom/intercom/no-bare-strings */
import Route from '@ember/routing/route';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';

export default class NewChartCustomReportRoute extends Route {
  @service store;
  @service appService;
  @service navbarCollapsingService;
  @service notificationsService;
  @service router;
  @service paywallService;
  @service intercomEventService;
  @service permissionsService;
  @service reportingMetrics;
  @service customReportsService;

  queryParams = {
    source: '',
    metricProperty: '',
    viewBy: '',
    metricId: '',
    isStandalone: false,
  };

  model(params) {
    let queryParams = this.paramsFor(this.routeName);
    let routeFromName = queryParams.isStandalone
      ? 'apps.app.standalone.reports.report.show'
      : 'apps.app.reports.custom-reports.report.show';
    let { report, settings } = this.modelFor(routeFromName);
    let metricId = params.metricId || this.reportingMetrics.defaultCustomChartMetric.id;
    let chart = this.store.createRecord('reporting/custom/chart', {
      chartSeries: [{ metricId }],
    });
    chart.updateMetric(metricId, chart.chartSeries.firstObject);

    if (params.viewBy) {
      chart.updateViewBy(params.viewBy);
    }
    return {
      report,
      settings,
      chart,
    };
  }

  get canChangeCustomReports() {
    return this.customReportsService.canChangeCustomReports;
  }
  @action
  async willTransition(transition) {
    let { report, chart } = this.modelFor(this.routeName);
    let currentPage = 'apps.app.reports.custom-reports.report.show.chart.new';
    let isPaywallActive = this.paywallService.isPaywallActive({
      featureName: 'custom_reports',
    });
    if (isPaywallActive) {
      chart.unloadRecord();
    } else if (transition.to.queryParams.cancelling && chart.isNew) {
      chart.unloadRecord();
    } else if (
      !transition.data.skipConfirmation &&
      !transition.to.queryParams.cancelling &&
      chart.isNew &&
      !transition.to.queryParams.cr2AddingToChart &&
      transition.to.name !== currentPage &&
      !isPaywallActive &&
      this.canChangeCustomReports
    ) {
      transition.abort();
      let confirmed = await this.customReportsService.confirmSave(false);
      if (confirmed === true) {
        transition.data.skipConfirmation = true;
        await report.saveChart(chart);
        this.notificationsService.notifyConfirmation('Your chart has been saved');
        transition.retry();
      } else if (confirmed.canceled) {
        transition.data.skipConfirmation = true;
        chart.unloadRecord();
        transition.retry();
      } else if (confirmed.closed) {
        // Workaround for https://github.com/emberjs/ember.js/issues/5210#issuecomment-623967508
        this.router.location.setURL(this.router.currentURL);
      }
    }
  }

  @action
  didTransition() {
    let params = this.paramsFor(this.routeName);
    this.intercomEventService.trackAnalyticsEvent({
      action: 'opened',
      object: 'chart_creator',
      from_url: params.source !== 'custom_report',
    });
  }
}
